import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Loading from "./components/Loading";
import { useAuth } from "./contexts/AuthContext";

const RequireAuth = () => {
  const { authStatus, isAuthenticated } = useAuth();
  const location = useLocation();

  if (authStatus === "loading") {
    return <Loading />;
  }

  if (!isAuthenticated) {
    const redirect = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(redirect)}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default RequireAuth;
